import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { publicAssets } from '@utils/url.utils';
import { rem } from 'polished';
import { CantFindYourDreamCarStyled } from '../CantFindYourDreamCarStyled';
export const CantFindYourDreamCarStyledDS = styled(CantFindYourDreamCarStyled)`
    background: linear-gradient(to top, ${({ theme }) => theme.colors.grey3}, white);

    @media (min-width: ${breakpoints.sm}px) {
        border-radius: ${rem('8px')};
    }

    .img {
        background-image: url('${publicAssets('/images/cantFindYourDreamCarDs_mob.png')}');

        @media (min-width: ${breakpoints.sm}px) {
            background-image: url('${publicAssets('/images/cantFindYourDreamCarDs.png')}');
        }
    }
`;
